module.exports = __webpack_public_path__ + "img/aluminyum.54746cc7.png";